var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7623 6.21821C16.1827 6.21821 15.7129 6.68795 15.7129 7.26763C15.7129 7.84731 16.1827 8.31705 16.7623 8.31705C17.342 8.31705 17.8118 7.84731 17.8118 7.26763C17.8118 6.68795 17.342 6.21821 16.7623 6.21821Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 7.57746C9.62632 7.57746 7.64741 9.56635 7.64741 12.005C7.64741 14.4536 9.63632 16.4325 12.075 16.4325C14.5236 16.4325 16.5025 14.4536 16.5025 12.005C16.5025 9.55636 14.5136 7.57746 12.075 7.57746ZM12.075 14.8434C10.5058 14.8434 9.23653 13.5741 9.23653 12.005C9.23653 10.4359 10.5058 9.16657 12.075 9.16657C13.6441 9.16657 14.9134 10.4359 14.9134 12.005C14.9134 13.5741 13.6441 14.8434 12.075 14.8434Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.593 21H8.40699C5.42864 21 3.00999 18.5813 3 15.593V8.407C3 5.42865 5.41865 3.00999 8.40699 3H15.593C18.5713 3 20.99 5.41866 21 8.407V15.593C21 18.5713 18.5813 20.99 15.593 21ZM8.41699 4.69906C6.36813 4.69906 4.70904 6.35813 4.70904 8.407V15.593C4.70904 17.6419 6.36813 19.3009 8.41699 19.3009H15.603C17.6519 19.3009 19.3109 17.6419 19.3109 15.593V8.407C19.3109 6.35813 17.6519 4.69906 15.603 4.69906H8.41699Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.232a0a58.svg";
export { ForwardRef as ReactComponent };